"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ImgThumb = void 0;
require("@alifd/next/es/overlay/style");
var _overlay = _interopRequireDefault(require("@alifd/next/es/overlay"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _close = _interopRequireDefault(require("./close.png"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ImgThumb = exports.ImgThumb = function ImgThumb(_ref) {
  var src = _ref.src,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    width = _ref.width,
    height = _ref.height,
    trigger = _ref.trigger,
    onVisibleChange = _ref.onVisibleChange;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    modalVisible = _useState2[0],
    setModalVisible = _useState2[1];
  var triggerEle = (0, _react.useRef)(null);
  if (!src) return null;
  var thumbStyle = {};
  if (width !== '' && width !== undefined) {
    thumbStyle.width = width;
  }
  if (height !== '' && height !== undefined) {
    thumbStyle.height = height;
  }
  if (thumbStyle.width && !thumbStyle.height) {
    thumbStyle.height = 'auto';
  } else if (thumbStyle.height && !thumbStyle.width) {
    thumbStyle.width = 'auto';
  }
  var handleShow = function handleShow() {
    onVisibleChange && onVisibleChange(true);
    setModalVisible(true);
  };
  var handleClose = function handleClose() {
    onVisibleChange && onVisibleChange(false);
    setModalVisible(false);
  };
  var opener = trigger ? /*#__PURE__*/_react.default.cloneElement(trigger, {
    onClick: handleShow,
    ref: triggerEle
  }) : /*#__PURE__*/_react.default.createElement("img", {
    alt: "\u6253\u5F00\u5927\u56FE",
    className: "mod-img-thumb",
    ref: triggerEle,
    src: src,
    style: thumbStyle,
    onClick: handleShow
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, opener, /*#__PURE__*/_react.default.createElement(_overlay.default, {
    visible: modalVisible,
    safeNode: function safeNode() {
      return triggerEle.current;
    },
    align: "cc cc",
    hasMask: true,
    disableScroll: true,
    shouldUpdatePosition: true,
    onRequestClose: handleClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mod-img-thumb-origin-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: alt,
    className: "mod-img-thumb-origin",
    src: src
  }))), modalVisible && /*#__PURE__*/_react.default.createElement("img", {
    alt: "\u5173\u95ED\u5927\u56FE",
    src: _close.default,
    style: {
      position: 'fixed',
      top: 0,
      right: 0,
      width: '60px',
      height: '60px',
      zIndex: 2000
    },
    onClick: handleClose
  }));
};
var _default = exports.default = ImgThumb;